import { ContentFrame, LayoutContent, LayoutContentBody, LayoutContentHeader, LayoutControls, ScreenContainer, } from '@pinwheel/origami';
import React from 'react';
import ModalHeader from '../../components/ModalHeader';
import WizardTermsFooter from './WizardTermsFooter';
export default function BaseWizardScreen(props) {
    var titleText = props.titleText, buttons = props.buttons, children = props.children, dataTestId = props.dataTestId, includeTermsFooter = props.includeTermsFooter;
    return (React.createElement(ScreenContainer, { "data-testid": dataTestId },
        React.createElement(ModalHeader, { "data-testid": "Wizard-ModalHeader" }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentHeader, { sx: {
                        '& > *': {
                            marginBottom: '0',
                        },
                        '& > *:last-child': {
                            marginBottom: '0',
                        },
                        padding: '1 0',
                        marginBottom: '4px',
                    }, title: titleText, subtitle: props.subtitleText }),
                React.createElement(LayoutContentBody, { sx: {
                        '& > *': {
                            marginBottom: '0',
                        },
                        '& > *:last-child': {
                            marginBottom: '0',
                        },
                    } }, children)),
            React.createElement(LayoutControls, { sx: { padding: '0 4 5', justifyContent: 'flex-end' } },
                includeTermsFooter && React.createElement(WizardTermsFooter, null),
                buttons))));
}
